import "./HelpDeskComponent.scss";
import React, {useCallback, useRef, useState} from "react";
import ButtonComponent from "../core/button/ButtonComponent";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from '@mui/icons-material/Remove';
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers, FormikProps, FormikValues} from "formik";
import commonService from "../../services/common.service";
import FormikInputComponent from "../core/formik-input/FormikInputComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import FileDragAndDropComponent from "../file-drag-n-drop/FileDragAndDropComponent";
import {AttachFile} from "@mui/icons-material";
import ChipComponent from "../chip/ChipComponent";

interface HelpDeskComponentProps {

}

const formValidationSchema = Yup.object({
    issueType: Yup.string()
        .required('Issue type is required'),
    summary: Yup.string()
        .min(5, 'Title must be at least 5 characters')
        .required('Title is required'),
    description: Yup.string()
        .min(10, 'Description must be at least 10 characters')
        .required('Description is required')
});

interface initialFormType {
    issueType: "Bug",
    summary: string,
    description: string,
    files: any[]
}

const initialFormValues: initialFormType = {
    issueType: 'Bug',
    summary: '',
    description: '',
    files: []
};

// const issueTypeDropdownOptions = [
//     {title: 'Task', code: "Task"},
//     {title: 'Bug', code: "Bug"},
//     // {title: 'Story', code: 'Story'}
// ]

const HelpDeskComponent = (props: HelpDeskComponentProps) => {
    const {currentUser} = useSelector((store: IRootReducerState) => store.account)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formValues, setFormValues] = useState<initialFormType>(initialFormValues);
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const onModalOpen = useCallback(() => {
        setIsModalOpen(true)
    }, [])
    const onModalClose = useCallback(() => {
        setIsModalOpen(false)
        setFormValues(initialFormValues)
    }, [])
    const onModalMinimize = useCallback(() => {
        setIsModalOpen(false)
    }, [])

    const handleResultFilesDrop = useCallback((files: any, setFieldValue: (field: string, value: any, shouldValidate?: (boolean | undefined)) => void) => {
        // const file = files[0];
        const allSelectedFiles = formikRef?.current?.values?.files;
        formikRef?.current?.setFieldValue("files", [...allSelectedFiles, ...files], true)
    }, []);

    const handleRemoveFile = useCallback((file: any) => {
        const updatedFiles = formikRef?.current?.values?.files.filter((fileItem: any) => fileItem.name !== file.name);
        formikRef?.current?.setFieldValue("files", updatedFiles, true)
    }, [])

    const onFormSubmit = useCallback((values: any, {setSubmitting, setErrors, resetForm}: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {...values};
        payload["description"] += ` \n \n Created By:${currentUser?.firstName || ""} ${currentUser?.lastName || ""}`;
        const formData = new FormData();
        if (payload?.files?.length > 0) {
            payload?.files.forEach((file: any) => {
                formData.append('files', file);
            })
        }
        Object.keys(payload).forEach((key: string) => {
            if (key !== 'files') {
                formData.append(key, payload[key]);
            }
        })
        commonService._ticket.createTicket(formData)
            .then((response: any) => {
                setSubmitting(false);
                resetForm(); // Reset form after successful submission
                onModalClose();
                commonService._alert.showToast("Submitted successfully", "success")
            })
            .catch((error: any) => {
                commonService.handleErrors(setErrors, error);
                setErrors(error);
                setSubmitting(false);
            })
    }, [currentUser?.firstName, currentUser?.lastName, onModalClose]);


    return (
        <div className={'help-desk-component'}>
            {!isModalOpen ?
                <ButtonComponent size={"large"}
                                 className={"help-desk-action-button"}
                                 handleClick={onModalOpen}
                                 variant={'contained'}
                                 color={"secondary"}>Need Help?</ButtonComponent> :
                <div className={'help-desk-modal-container'}>
                    <div className="help-desk-header">
                        <div className="help-desk-title">Raise ticket here</div>
                        <div className="help-desk-close-icon">
                            <RemoveIcon onClick={onModalMinimize}/>
                            <CloseIcon className={"mrg-left-8"} onClick={onModalClose}/>
                        </div>
                    </div>
                    <div className="help-desk-body">
                        <Formik
                            validationSchema={formValidationSchema}
                            initialValues={formValues}
                            validateOnChange={true}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            onSubmit={onFormSubmit}
                            innerRef={formikRef}
                        >
                            {({values, validateForm, isValid, isSubmitting, setFieldValue}) => {
                                return (
                                    <div className="t-form">
                                        <Form noValidate={true}>
                                            <div className="t-form-controls help-desk-form-controls">
                                                {/*<Field name={'issueType'} className="t-form-control">*/}
                                                {/*    {*/}
                                                {/*        (field: FieldProps) => (*/}
                                                {/*            <div className={"pdd-top-5"}>*/}
                                                {/*                <FormikSelectDropdownComponent*/}
                                                {/*                    label={'Issue Type'}*/}
                                                {/*                    placeholder={'Select Issue Type'}*/}
                                                {/*                    required={true}*/}
                                                {/*                    valueKey={'code'}*/}
                                                {/*                    options={issueTypeDropdownOptions}*/}
                                                {/*                    formikField={field}*/}
                                                {/*                    getOptionLabel={(option => (option.title) || '')}*/}
                                                {/*                />*/}
                                                {/*            </div>*/}
                                                {/*        )*/}
                                                {/*    }*/}
                                                {/*</Field>*/}
                                                <Field name={'files'} className="t-form-control">
                                                    {
                                                        (field: FieldProps) => (
                                                            <>
                                                                <FileDragAndDropComponent
                                                                    multiple={true}
                                                                    // title={"Attachments image/pdf"}
                                                                    onFilesDrop={(value: any) => {
                                                                        handleResultFilesDrop(value, setFieldValue)
                                                                    }}
                                                                    acceptedFileTypes={{
                                                                        'application/pdf': [],
                                                                        'image/jpeg': [],
                                                                        'image/png': [],
                                                                    }}
                                                                    fileSizeLimitText={"PNG, JPEG and PDF files are allowed upto 10MB. Multiple file upload is allowed."}
                                                                />
                                                                {
                                                                    values?.files?.map((file: any) => {
                                                                        return <ChipComponent
                                                                            label={file?.name}
                                                                            onDelete={() => {
                                                                                handleRemoveFile(file);
                                                                            }}
                                                                            icon={<AttachFile/>}
                                                                            className={'attachment-chip-item mrg-bottom-15 mrg-right-15'}
                                                                        />
                                                                    })
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </Field>
                                                <Field name={'summary'} className="t-form-control">
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Title'}
                                                                placeholder={'Enter Title'}
                                                                required={true}
                                                                formikField={field}
                                                                fullWidth={true}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                                <Field name={'description'} className="t-form-control">
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Description'}
                                                                placeholder={'Enter description'}
                                                                required={true}
                                                                formikField={field}
                                                                fullWidth={true}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </div>
                                            <div className="t-form-actions form-action-section mrg-bottom-0">
                                                <ButtonComponent
                                                    isLoading={isSubmitting}
                                                    variant={"contained"}
                                                    color={"primary"}
                                                    disabled={isSubmitting || !isValid}
                                                    type={"submit"}
                                                    size={"large"}
                                                    fullWidth={true}
                                                >
                                                    Submit
                                                </ButtonComponent>
                                            </div>
                                        </Form>
                                    </div>
                                )
                            }}
                        </Formik>
                    </div>
                </div>}
        </div>
    );

};

export default HelpDeskComponent;
